import { Box, Link, Typography } from '@mui/material'
import React from 'react'
import Grid from '@mui/material/Grid2';
import { ReactFitty } from 'react-fitty';
import TransitEnterexitIcon from '@mui/icons-material/TransitEnterexit';
import img1 from '../../assets/img/project2Page/img1.png'
import img2 from '../../assets/img/project2Page/img2.png'

const Project1 = () => {
  return (
    <Box height={"100dvh"} sx={{ backgroundColor: '#e5e8d9' }}>
      <Link href={'https://greenavi.com'} target={'_blank'}>
        <Box sx={{
          position: 'absolute',
          right: 0,
          top: 0,
          backgroundColor: '#191b1e',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <TransitEnterexitIcon sx={{
            fontSize: '4rem',
            color: '#e5e8d9',
            '@media screen and (max-width: 600px)': {
              fontSize: '2rem',
            }
          }} />
        </Box>
      </Link>
      <Box sx={{
        padding: '100px',
        // height: '20%',
        borderBottom: '4px solid #fd4002',
        '@media screen and (max-width: 600px)': {
          padding: '40px',
        }
      }}>
        <Typography
          sx={{ textAlign: 'center', position: 'relative', zIndex: 2, lineHeight: 0.7, color: '#fd4002' }}
          component={ReactFitty}
        >
          P2P- и B2B-ОБМЕННИК
        </Typography>
        <Typography
          color='secondary'
          sx={{
            fontFamily: "Great Vibes",
            textAlign: 'left',
            position: 'relative',
            zIndex: 3,
            width: '100%',
            fontSize: '4rem',
            padding: '0 30px',
            marginTop: '-35px',
            lineHeight: 0.7,
            '@media screen and (max-width: 600px)': {
              fontSize: '2rem',
              marginTop: '-20px',
            }
          }}>
          Project 02
        </Typography>
      </Box>
      <Grid
        container
        spacing={0}
        height={'82%'}
        sx={{
          backgroundColor: '#e5e8d9',
          zIndex: 1,
          position: 'relative',
          marginTop: '-130px',
          '@media screen and (max-width: 600px)': {
            marginTop: '-57px',
          }
        }}
      >
        <Grid size={7} sx={{
          height: '100%',
          '@media screen and (max-width: 1200px)': {
            display: 'none'
          }
        }}>
          <img src={img1} alt="exmpl-img" style={{ height: '100%', width: '100%' }} />
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
            <Box sx={{
              height: '100%',
              overflow: 'hidden',
              '& img': {
                '@media screen and (max-width: 1200px)': {
                  marginLeft: '-80px',
                  width: '200% !important'
                }
              }
            }}>
              <img src={img2} alt="exmpl-img" style={{ height: '100%', width: '100%' }} />
            </Box>
            <Grid container spacing={0}>
              <Grid size={11}
                sx={{
                  padding: "50px",
                  '@media screen and (max-width: 600px)': {
                    padding: '20px'
                  }
                }}>
                <Typography
                  color='secondary'
                  gutterBottom
                  sx={{
                    '@media screen and (max-width: 600px)': {
                      fontSize: '0.8rem'
                    }
                  }}
                >
                  Криптовалютный обменник (P2P & B2B)
                </Typography>
                <Typography
                  color='secondary'
                  gutterBottom
                  sx={{
                    '@media screen and (max-width: 600px)': {
                      fontSize: '0.8rem'
                    }
                  }}
                >
                  Разработана гибкая и безопасная платформа для P2P (пользователь-пользователь) и B2B (бизнес-бизнес) обмена криптовалют, обеспечивающая быстрые сделки и защиту пользователей.
                </Typography>
                <Typography
                  color='secondary'
                  gutterBottom
                  sx={{
                    '@media screen and (max-width: 600px)': {
                      fontSize: '0.8rem'
                    }
                  }}
                >
                  Платформа ориентирована на быстроту, безопасность и удобство для пользователей и бизнеса.
                </Typography>
              </Grid>
              <Grid size={1} sx={{ backgroundColor: '#191b1e' }}></Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Project1